import { render, staticRenderFns } from "./addBrand.vue?vue&type=template&id=3a40abf8&"
import script from "./addBrand.vue?vue&type=script&lang=js&"
export * from "./addBrand.vue?vue&type=script&lang=js&"
import style0 from "./addBrand.vue?vue&type=style&index=0&id=3a40abf8&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports